<div class="tt-c-question-container">
  <slot name="soloQHeader"></slot>
  <div class="tt-c-question">
    <div class="tt-c-question__votes">
      <tt-button type="toolbar" class="tt-c-question__upvote" :class="{'tt-o-button--selected': wasVotedOn}" :disabled="!canVote"
        @click="vote" :aria-label="$msg('question.voteUp', [voteCount], voteCount)" :aria-pressed="wasVotedOn.toString()">
        <tt-icon :name="voteIconName" size="md"></tt-icon><span class="tt-c-question__upvote-count">{{voteCount}}</span>
      </tt-button>
    </div>
    <div class="tt-c-question__body tt-u-spacing--xs">
      <div class="tt-c-question__title" :role="headingLevel ? 'heading' : null" :aria-level="headingLevel" v-html="question.text"></div>
      <tt-product-about v-if="isRelated" :catItem="question.catItem" imageSize="SS" class="tt-c-question__related tt-u-mb--md"></tt-product-about>
      <tt-byline :item="question" ugcType="sq"></tt-byline>
      <div v-if="question.multiItems.length > 0" class="tt-c-question__multi-items">
        <tt-product-about v-for="multiItem in question.multiItems" :catItem="multiItem" imageSize="SS" :showAbout="false"></tt-product-about>
      </div>
      <tt-answer v-if="bestAnswer"
                  ref="bestAnswer"
                  :answer="bestAnswer"
                  :isBestAnswer="true"
                  :isOnlyAnswer="question.answers.length === 1"
                  :originSiteKey="originSiteKey"
                  :style="bestAnswerStyles"
                  :key="bestAnswer.id"></tt-answer>
    </div>
  </div>
  <div class="tt-c-question__answers">
    <div class="tt-c-question__actions" v-if="showActions">
      <tt-button v-if="expanderData" 
                 type="toolbar"
                 class="tt-c-question__actions-show"
                 @click="toggleShowHideAnswers"
                 :aria-expanded="expanderData.expanded"
                 :aria-controls="'tt-answer-list-' + question.id">
        <tt-icon :name="expanderData.icon" size="sm"></tt-icon><span class="tt-o-expander__text" v-html="expanderData.text"></span>
      </tt-button>
      <tt-button v-if="!hideAddAnswer"
                 ref="addAnswer"
                 type="toolbar"
                 class="tt-c-question__actions-answer"
                 :aria-controls="controlsId"
                 :aria-expanded="showAnswerForm.toString()"
                 :disabled="addAnswerDisabled"
                 @click="showAnswerForm = true">
        <tt-icon name="write" size="sm"></tt-icon><span v-html="$msg('question.answer')"></span></tt-button>
      <a v-if="isModerator" :href="moderationUrl" target="_blank" class="tt-c-question__actions-moderate" rel="nofollow">
          <tt-icon name="moderate" size="sm"></tt-icon><span v-html="$msg('question.moderate')"></span></a>
    </div>
    <tt-answer-form v-if="showAnswerForm"
                    :id="controlsId"
                    :hideCancel="hideAnswerFormCancel"
                    :originSiteKey="originSiteKey"
                    parentType="question"
                    :parent="question"
                    @close="closeForm"></tt-answer-form>
    <div v-show="showAnswers" :id="'tt-answer-list-' + question.id" class="tt-c-question__answer-list">
      <template v-if="showAnswers">
        <tt-answer v-for="answer in question.answers"
                  :answer="answer"
                  :isOnlyAnswer="question.answers.length === 1"
                  :originSiteKey="originSiteKey"
                  :key="answer.id"></tt-answer>
        <div class="tt-c-answer__help">
          <div class="tt-c-answer__votes">
            <tt-icon name="helpful-on" size="sm"></tt-icon>
          </div>
          <div class="tt-c-answer__body">
            <p class="tt-c-answer__help-text" v-html="$msg('question.voteForAbove')"></p>
          </div>
        </div>
      </template>
    </div>
  </div>
</div>
